import type { BackgroundTask } from "../composables/useBackgroundTasks";

export function isBackgroundTaskActive(task: { status: string } | null | undefined) {
  return task?.status === "queued" || task?.status === "running";
}
export function backgroundTaskPercent(task: BackgroundTask) {
  return task.status === "ready" ? 100 : task.total ? Math.max(0, Math.min(100, Math.round((task.processed ?? 0) / task.total * 100))) : 0;
}
export function backgroundTaskStatusLabel(task: BackgroundTask) {
  return ({ ready: "Prêt", failed: "Échec", cancelled: "Annulé" } as Record<string, string>)[task.status] ?? `${backgroundTaskPercent(task)} %`;
}
export function backgroundTaskMessage(task: BackgroundTask) {
  if (task.message) return task.message;
  if (task.status === "failed") return "Le serveur a interrompu la préparation. Aucun fichier disponible.";
  if (task.status === "cancelled") return "La préparation est arrêtée. Aucun fichier disponible.";
  if (task.status === "ready") return "La tâche est terminée.";
  if (!task.processed) return "Préparation du fichier · vous pouvez quitter la page";
  return `${task.processed.toLocaleString("fr-FR")} / ${(task.total ?? 0).toLocaleString("fr-FR")} · vous pouvez quitter la page`;
}
